import { SurveyDeployerPageResponseJSON } from './../Survey-Deployer-Page-Response-JSON';
import { PageHeaderResponseJSON } from './../surveyHeader/Page-Header-Response-JSON';
import { WCPageDetailsResponseJSON } from './WC-Page-Details-Response-JSON';
import { PageFooterResponseJSON } from './../surveyFooter/Page-Footer-Response-JSON';
import { SurveyDeployerConfigResponseJSON } from './../surveyConfig/Survey-Deployer-Config-Response-JSON';
import { SurveyDeployerWCPageValidationJSON } from './Survey-Deployer-WCPage-Validation-JSON';

export class SurveyDeployerWCPageResponseJSON extends SurveyDeployerPageResponseJSON {
    wCPageHeaderResponseJSON: PageHeaderResponseJSON;
    wCPageDetailsResponseJSON: WCPageDetailsResponseJSON;
    wCPageFooterResponseJSON: PageFooterResponseJSON;
    surveyDeployerConfigResponseJSON: SurveyDeployerConfigResponseJSON;
    surveyDeployerWCPageValidationJSON: SurveyDeployerWCPageValidationJSON;
}